// SEO configuration centrale pour Batisur Connect
// Mots-clés basés sur les recherches réelles françaises à forte intention commerciale
// (source : SEMrush FR + Google Keyword Planner + tendances BTP 2026)

const SITE = "https://www.batisur-connect.com";
const DEFAULT_IMAGE = `${SITE}/og-image.png`;
const BRAND = "Batisur Connect";

// Base keywords partagés partout — attirent particuliers ET artisans
const BASE_KEYWORDS = [
  // Sécurité paiement (intention forte particulier)
  "paiement sécurisé travaux", "séquestre travaux BTP", "escrow travaux",
  "protéger acompte artisan", "arnaque artisan comment éviter", "chantier abandonné recours",
  "acompte travaux sécurisé", "garantie financière artisan",
  // Recherche artisan (intention forte particulier)
  "trouver artisan de confiance", "artisan SIRET vérifié", "artisan certifié",
  "artisan RGE recommandé", "annuaire artisan BTP", "artisan avis vérifiés",
  // Côté artisan (intention forte pro)
  "trouver chantiers artisan", "chantier pour artisan", "artisan sans impayé",
  "garantie paiement artisan", "logiciel devis facture artisan", "artisan factur-x 2026",
  // Marketplace / plateforme
  "plateforme travaux sécurisée", "marketplace BTP France", "site travaux fiable",
  "Batisur", "Batisur Connect",
].join(", ");

// Configs par route
export const SEO_CONFIG = {
  "/": {
    title: "Batisur Connect · Paiement sécurisé travaux BTP · Séquestre Stripe & preuves opposables",
    description: "Plateforme française N°1 de sécurisation des travaux BTP. Séquestre Stripe, artisans SIRET vérifiés Sirene/INSEE, preuves photos horodatées, médiateurs nommés, Factur-X 2026. Particuliers, promoteurs, architectes, syndics — payez uniquement quand vous êtes satisfaits. Artisans : 30 jours Pack Or offerts, paiement garanti 100%.",
    keywords: [
      BASE_KEYWORDS,
      // Long-tail conversion particulier
      "comment sécuriser paiement travaux maison", "empêcher artisan de fuir avec acompte",
      "protéger 20000 euros travaux rénovation", "artisan qui ne finit pas les travaux que faire",
      "abandonnement chantier artisan recours 2026", "conflit artisan client médiation",
      "certificat fin travaux opposable assurance décennale", "preuve photo travaux justice",
      // Long-tail artisan
      "artisan retard paiement client solution", "artisan comment être payé sans risque",
      "logiciel gestion chantier artisan gratuit", "artisan trouver clients pipeline",
      "artisan devis en ligne gratuit", "artisan facturation obligatoire 2026",
      // Types de travaux (super forte intention)
      "rénovation salle de bain sécurisée", "extension maison paiement sécurisé",
      "gros œuvre paiement échelonné", "second œuvre garanties financières",
      "plomberie électricité maçonnerie sécurisé",
    ].join(", "),
    ogType: "website",
    canonical: "/",
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": BRAND,
        "url": SITE,
        "logo": `${SITE}/icons/icon-512.png`,
        "description": "Marketplace française BTP sécurisée : paiement en séquestre Stripe, artisans SIRET vérifiés, preuves opposables.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "29 rue Tronchet",
          "addressLocality": "Paris",
          "postalCode": "75008",
          "addressCountry": "FR"
        },
        "sameAs": [
          "https://www.batisur-connect.com"
        ],
        "areaServed": "FR",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": BRAND,
        "url": SITE,
        "potentialAction": {
          "@type": "SearchAction",
          "target": `${SITE}/artisans?q={search_term_string}`,
          "query-input": "required name=search_term_string"
        }
      },
      // FAQPage → déclenche les résultats enrichis (accordéon dans Google)
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Comment sécuriser le paiement de travaux BTP avec un artisan ?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sur Batisur Connect, votre paiement est bloqué chez Stripe (agréé bancaire européen) dès la signature du devis. L'artisan voit les fonds sécurisés mais ne peut y toucher. Vous validez la libération uniquement après avoir vu les photos horodatées des travaux terminés. Aucun risque de fuite ni de chantier inachevé."
            }
          },
          {
            "@type": "Question",
            "name": "Que faire si mon artisan abandonne le chantier ?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Tant que les fonds sont en séquestre, l'artisan ne touche rien. Vous pouvez saisir notre équipe médiation Batisur (personnes réelles) qui tranche sous 30 jours en analysant le journal photo horodaté. En dernier recours, vous récupérez vos fonds intégralement."
            }
          },
          {
            "@type": "Question",
            "name": "Puis-je inviter mon propre artisan sur Batisur ?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Oui absolument. Invitez votre artisan de confiance par email en 1 clic depuis votre mission. Il rejoint Batisur en 1 minute, envoie son devis, vous sécurisez ensemble le paiement en séquestre. Invitations illimitées et gratuites."
            }
          },
          {
            "@type": "Question",
            "name": "Comment un artisan est-il sûr d'être payé sur Batisur ?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "L'artisan voit dans son dashboard que les fonds sont déjà bloqués chez Stripe AVANT de commencer les travaux. Zéro chèque sans provision, zéro relance à 90 jours. Le paiement est garanti à 100% dès que les preuves photos de finition sont publiées et validées."
            }
          },
          {
            "@type": "Question",
            "name": "Combien coûte Batisur Connect ?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Inscription gratuite. Commission dégressive par palier marginal : 10% jusqu'à 5000€, puis 7% jusqu'à 25000€, 5% jusqu'à 100000€, 3% jusqu'à 500000€, 1,5% au-delà. Aucun frais caché, aucun frais sur devis non acceptés. Facture TVA 20% conforme émise automatiquement."
            }
          },
          {
            "@type": "Question",
            "name": "Batisur est-il compatible avec la facturation électronique Factur-X 2026 ?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Oui, toutes les factures Batisur sont générées au format PDF/A-3 avec XML CII embedded, conformes à la norme Factur-X obligatoire 2026. Les artisans Pack Or économisent 15€/mois d'abonnement à un logiciel de facturation externe."
            }
          }
        ]
      }
    ]
  },

  "/pro/rejoindre": {
    title: "Devenir artisan Batisur · 30 jours Pack Or gratuits · Factur-X 2026 inclus",
    description: "Artisan du bâtiment : rejoignez la marketplace française qui garantit 100% de vos paiements par séquestre Stripe. Fini les impayés, les chèques sans provision, les relances à 90 jours. 30 jours Pack Or offerts, badge SIRET officiel, mise en avant annuaire, Factur-X 2026 inclus. Plomberie, électricité, maçonnerie, menuiserie, peinture, carrelage, isolation, toiture, plâtrerie, chauffage.",
    keywords: [
      "devenir artisan Batisur", "inscription artisan gratuite", "trouver clients BTP",
      "artisan sans impayé", "artisan garantie paiement 100%", "artisan chèque sans provision solution",
      "plateforme artisan France gratuite", "annuaire artisan SIRET", "badge artisan certifié",
      "artisan pack premium mise en avant", "artisan pack or fonctionnalités",
      "logiciel devis facturation artisan gratuit", "artisan factur-x obligatoire 2026",
      "artisan gestion chantier photo", "artisan pipeline missions",
      "artisan plombier trouver clients", "artisan électricien chantiers",
      "artisan maçon appel offres", "artisan peintre demandes travaux",
      "artisan menuisier missions locales", "artisan carreleur clients qualifiés",
      "artisan chauffagiste installations", "artisan couvreur devis",
      "artisan plaquiste isolation", "artisan RGE label chantiers",
      "auto-entrepreneur BTP plateforme", "SASU artisan sécurité paiement",
      "TPE BTP développement clientèle", "artisan qualibat qualifelec référencement",
      "reprise chantier abandonné artisan", "sous-traitance BTP sécurisée",
    ].join(", "),
    ogType: "website",
    canonical: "/pro/rejoindre",
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Plateforme de sécurisation des paiements pour artisans du BTP",
        "provider": {
          "@type": "Organization",
          "name": BRAND,
          "url": SITE
        },
        "areaServed": {
          "@type": "Country",
          "name": "France"
        },
        "audience": {
          "@type": "BusinessAudience",
          "audienceType": "Artisans BTP, auto-entrepreneurs, TPE, PME du bâtiment"
        },
        "offers": {
          "@type": "Offer",
          "name": "30 jours Pack Or offerts à l'inscription",
          "price": "0",
          "priceCurrency": "EUR",
          "availability": "https://schema.org/InStock"
        }
      }
    ]
  },

  "/pour-qui": {
    title: "Batisur pour architectes, promoteurs, syndics, bailleurs · BTP sécurisé",
    description: "Sécurisez vos chantiers quel que soit votre profil : particulier, architecte, promoteur immobilier, constructeur CMI, syndic de copropriété, bailleur, foncière, entreprise BTP, collectivité, maître d'œuvre, investisseur. Batisur adapte son escrow à votre volume et vos process. Multi-corps de métier, sous-traitance sécurisée, patrimoine locatif protégé.",
    keywords: [
      "sécuriser travaux copropriété", "outil syndic travaux gestion",
      "promoteur immobilier plateforme BTP", "architecte suivi paiement chantier",
      "constructeur CMI garantie paiement", "bailleur foncière patrimoine travaux",
      "collectivité mairie appel offres travaux", "maître d'œuvre coordination indépendante",
      "investisseur marchand biens rénovation", "particulier travaux protection consommateur",
      "syndic copropriété travaux parties communes", "conseil syndical résolution travaux",
      "SCPI immobilier travaux locatif", "gestionnaire biens rénovation sécurisée",
      "promoteur multi-lots BTP paiement", "lotissement viabilisation paiement",
      "entreprise BTP sous-traitance sécurisée", "donneur ordre BTP séquestre",
      "collectivité territoriale travaux plateforme", "établissement public travaux",
      "maître d'ouvrage délégué outil", "AMO assistance maîtrise ouvrage plateforme",
      "cabinet architecture logiciel client", "bureau études BTP suivi paiement",
      "expert construction plateforme travaux",
    ].join(", "),
    ogType: "website",
    canonical: "/pour-qui",
  },

  "/artisans": {
    title: "Annuaire artisans BTP SIRET vérifiés Sirene/INSEE · Batisur Connect",
    description: "Trouvez un artisan de confiance vérifié SIRET en temps réel via la base Sirene/INSEE. Plombier, électricien, maçon, menuisier, peintre, carreleur, chauffagiste, couvreur, plaquiste, plâtrier, isolation, RGE. Chaque artisan Batisur est identifié légalement, ses avis sont vérifiés, son ratio de missions terminées est public. Sécurisez votre paiement en séquestre.",
    keywords: [
      "annuaire artisan SIRET vérifié France", "trouver artisan certifié",
      "artisan avec avis vérifiés", "artisan de confiance recommandé",
      "artisan RGE près chez moi", "artisan qualibat qualifelec",
      "plombier SIRET Paris Lyon Marseille", "électricien certifié Toulouse Bordeaux",
      "maçon vérifié Nantes Lille Rennes", "menuisier local Strasbourg Montpellier",
      "peintre professionnel Nice Grenoble", "carreleur reconnu Angers Rouen",
      "chauffagiste PAC pompe chaleur", "couvreur zinc ardoise tuile",
      "plaquiste placo Ba13", "plâtrier traditionnel",
      "artisan isolation thermique extérieure ITE", "artisan photovoltaïque installation",
      "artisan pompe à chaleur RGE", "artisan étanchéité toit terrasse",
      "artisan ravalement façade", "artisan démolition curage",
      "artisan cuisiniste sur mesure", "artisan salle de bain complète",
      "artisan parquet stratifié", "artisan carrelage grand format",
      "artisan portes fenêtres double vitrage", "artisan volets roulants motorisés",
      "artisan alarme sécurité maison", "artisan piscine terrasse",
    ].join(", "),
    ogType: "website",
    canonical: "/artisans",
  },

  "/estimer": {
    title: "Estimateur travaux BTP gratuit · Prix rénovation en 2 min · Batisur",
    description: "Estimez gratuitement le prix de vos travaux en 2 minutes : rénovation salle de bain, cuisine, extension maison, isolation, plomberie, électricité, peinture, sol, toiture. Fourchette basse-haute basée sur les tarifs 2026 des artisans SIRET vérifiés Batisur. Sans inscription, sans email, sans engagement.",
    keywords: [
      "estimation travaux gratuit en ligne", "simulateur prix travaux BTP",
      "prix rénovation salle de bain 2026", "budget rénovation cuisine complète",
      "coût extension maison 20m2", "prix isolation combles perdus",
      "tarif ravalement façade m2", "prix rénovation appartement complète",
      "estimer travaux maison à vendre", "budget rénovation énergétique",
      "coût pompe à chaleur installation", "prix panneaux photovoltaïques 2026",
      "tarif carrelage pose fournitures", "prix peinture appartement au m2",
      "budget rénovation studio Paris", "estimer travaux rénovation locative",
      "prix installation cuisine équipée", "coût agrandissement maison ossature bois",
      "tarif isolation extérieure ITE aide MaPrimeRénov", "prix menuiserie sur mesure",
      "budget travaux avant achat immobilier", "estimation devis travaux gratuit sans engagement",
    ].join(", "),
    ogType: "website",
    canonical: "/estimer",
  },

  "/register": {
    title: "Inscription Batisur · Créer compte gratuit particulier ou artisan · 60 secondes",
    description: "Créez votre compte Batisur en 60 secondes. Particulier ou artisan, inscription gratuite, sans CB, sans engagement. Artisans : 30 jours Pack Or offerts. Particuliers : accès immédiat à l'annuaire d'artisans SIRET vérifiés et à l'escrow Stripe. Rejoignez la marketplace BTP française la plus sécurisée.",
    keywords: [
      "inscription Batisur gratuite", "créer compte artisan BTP",
      "s'inscrire marketplace travaux", "compte demandeur travaux",
      "compte artisan pack or gratuit 30 jours",
    ].join(", "),
    ogType: "website",
    canonical: "/register",
  },

  "/login": {
    title: "Connexion Batisur · Espace particulier ou artisan sécurisé",
    description: "Connectez-vous à votre espace Batisur Connect : suivi de missions, journal photos horodatées, séquestre Stripe, messagerie sécurisée demandeur ↔ artisan.",
    keywords: "connexion Batisur, login artisan, espace particulier travaux, dashboard artisan",
    ogType: "website",
    canonical: "/login",
    noindex: false,
  },

  "/pro/premium": {
    title: "Pack Premium & Pack Or Batisur · Mise en avant artisan · SIRET vérifié",
    description: "Boostez votre visibilité artisan avec Pack Premium (29€/mois : badge vérifié + mise en avant annuaire) ou Pack Or (49€/mois : SIRET officiel + top annuaire + Factur-X 2026 inclus). Rentabilisé dès la 1ère mission additionnelle. 30 jours d'essai gratuit inclus.",
    keywords: [
      "artisan pack premium mise en avant", "artisan pack or badge officiel",
      "artisan factur-x 2026 inclus abonnement", "artisan visibilité annuaire top",
      "abonnement artisan rentable ROI", "artisan mise en avant annuaire local",
    ].join(", "),
    ogType: "website",
    canonical: "/pro/premium",
  },

  "/artisans/villes": {
    title: "Artisans BTP par ville · Annuaire local France · Batisur Connect",
    description: "Trouvez un artisan SIRET vérifié dans votre ville : Paris, Lyon, Marseille, Toulouse, Bordeaux, Nantes, Lille, Rennes, Strasbourg, Montpellier, Nice et 100+ villes françaises. Sélection locale, avis vérifiés, paiement sécurisé escrow.",
    keywords: [
      "artisan Paris SIRET vérifié", "artisan Lyon annuaire",
      "artisan Marseille certifié", "artisan Toulouse local",
      "artisan Bordeaux qualité", "artisan Nantes recommandé",
      "artisan Lille Rennes Strasbourg", "artisan Montpellier Nice Grenoble",
      "artisan près de chez moi certifié", "annuaire artisan local français",
    ].join(", "),
    ogType: "website",
    canonical: "/artisans/villes",
  },

  "/cgu": {
    title: "Conditions Générales d'Utilisation · Batisur Connect",
    description: "Conditions Générales d'Utilisation de Batisur Connect SAS, marketplace BTP française sécurisée.",
    keywords: "CGU Batisur, conditions utilisation marketplace travaux",
    ogType: "website",
    canonical: "/cgu",
    noindex: true,
  },
  "/cgv": {
    title: "Conditions Générales de Vente · Batisur Connect",
    description: "CGV Batisur Connect : commission, escrow Stripe, libération des fonds, litiges et médiation.",
    keywords: "CGV Batisur, conditions vente séquestre",
    ogType: "website",
    canonical: "/cgv",
    noindex: true,
  },
  "/mentions-legales": {
    title: "Mentions légales · Batisur Connect SAS",
    description: "Mentions légales Batisur Connect SAS, siège social 29 rue Tronchet 75008 Paris.",
    keywords: "mentions légales Batisur",
    ogType: "website",
    canonical: "/mentions-legales",
    noindex: true,
  },
};

export const SITE_URL = SITE;
export const SITE_BRAND = BRAND;
export const DEFAULT_OG_IMAGE = DEFAULT_IMAGE;
export const GOOGLE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJwwClqxFv5kcRPrXqNSakQM4";

export function getSEO(pathname) {
  return SEO_CONFIG[pathname] || SEO_CONFIG["/"];
}
